<template>
  <div>
    <MainNavigation :routeIndex="routeIndex" />
    <NotificationBar msg-text="Add your class details" />
    <form style="text-align: left">
      <div class="nickname">
        <h2>Add a New Class</h2>
        <p><strong>Give your class a nickname you can remember</strong></p>
        <div class="flex-container-row ">
        <input type="text" v-model="newClass.nickname" placeholder="Enter Class Name" required/>
        <span><strong>*Required</strong></span>
        </div>
      </div>
      <div id="addClass">
        <h3>What grade is your class?</h3>
        <div id="grade" class="grade">
          
          <label for="6"><input
            id="6"
            type="radio"
            name="grade"
            value="6"
            v-model="newClass.grade"
          /><p>6th grade</p></label>
          
          <label for="7"><input
            id="7"
            type="radio"
            name="grade"
            value="7"
            v-model="newClass.grade"
          /><p>7th grade</p></label>
          
          <label for="8"><input
            id="8"
            type="radio"
            name="grade"
            value="8"
            v-model="newClass.grade"
          /><p>8th grade</p></label>
          
          <label for="other"><input
            id="other"
            type="radio"
            value="Other"
            name="grade"
            v-model="newClass.grade"
          /><p>Other</p></label>
        </div>
        <h3>What subject is your class? (optional)</h3>
        <p>This helps if you have more than one subject.</p>
        <div id="subject" class="subject">
          
          <label for="english"><input
            id="english"
            name="subject"
            type="radio"
            value="English/ELA"
            v-model="newClass.subject"
          /><p>English/ELA</p></label>
          
          <label for="history"><input
            id="history"
            name="subject"
            type="radio"
            value="History"
            v-model="newClass.subject"
          /><p>History</p></label> 
          
          <label for="other-subject"><input
            id="other-subject"
            type="radio"
            value="Other"
            name="subject"
            v-model="newClass.subject"
          /><p>Other</p></label> 
        </div>
        <h3>What days are your class? (optional)</h3>
        <p>This helps if your class meets mutliple days a week.</p>
        <div id="day" class="day">
          <label>
          <input
            id="monday"
            type="checkbox"
            name="day"
            value="Monday"
            v-model="newClass.checkedDay"
          />
          <p>Monday</p></label>
          <label>
          <input
            id="tuesday"
            type="checkbox"
            name="day"
            value="Tuesday"
            v-model="newClass.checkedDay"
          />
          <p>Tuesday</p></label>
          <label>
          <input
            id="wednesday"
            type="checkbox"
            name="day"
            value="Wednesday"
            v-model="newClass.checkedDay"
          />
          <p>Wednesday</p></label>
          <label>
          <input
            id="thursday"
            type="checkbox"
            name="day"
            value="Thursday"
            v-model="newClass.checkedDay"
          />
          <p>Thursday</p></label>
          <label>
          <input
            id="friday"
            type="checkbox"
            name="day"
            value="Friday"
            v-model="newClass.checkedDay"
          />
          <p>Friday</p></label>
          <label>
          <input
            id="saturday"
            type="checkbox"
            name="day"
            value="Saturday"
            v-model="newClass.checkedDay"
          />
          <p>Saturday</p></label>
          <label>
          <input
            id="sunday"
            type="checkbox"
            name="day"
            value="Sunday"
            v-model="newClass.checkedDay"
          />
          <p>Sunday</p></label>
        </div>
        <div class="button-container">
          <button class="back-button" type="button" @click="goBack()">
            Back
          </button>
          <button :disabled="newClass.nickname == ''" class="save-button" type="button" @click="createNewClass()">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";

export default {
  name: "NewClass",
  components: {
    MainNavigation,
    NotificationBar,
  },
  props: ["routeIndex"],
  data() {
    return {
      newClass: {
        nickname: "",
        grade: "",
        subject: "",
        checkedDay: [],
      },
    };
  },
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
  },

  methods: {
    createNewClass() {
      this.$store.commit("SEND_MESSAGE", {
        data: this.newClass,
        opCode: this.$store.state.opCodes.SetClassInfo,
      });
      this.$store.commit("SET_NEWCLASS_ADDED", true);
      this.$router.push({
        name: "class-list",
      });
    },
    goBack() {
      return this.$router.go(-1);
    },
  },
};
</script>

<style>
.button-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 20px;
  margin: 2rem 0;
}

.save-button a {
  color: #fff;
  text-decoration: none;
}

.nickname input {
  margin-bottom: 1rem;
}

.grade label, .subject label, .day label {
  display: flex;
  align-items: center;
  width: 100%;
  /*border: 1px solid #BDBDBD;*/
}

.grade label input, .subject label input, .day label input  {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

input[type="radio"]:checked {
  background: #333;
}

.grade label input:focus, .subject label input:focus, .day label input:focus {
  box-shadow: none;
}

</style>